import React, { useMemo } from "react";
import DOMPurify from "dompurify";

/**
 * SafeHtml — the ONLY place we should ever set inner HTML from server strings.
 * Wraps DOMPurify with an allow-list tuned for the Tiptap editor output +
 * transactional email bodies used in the inbox thread.
 *
 * Usage:  <SafeHtml html={article.body_ar} className="prose text-navy/80" />
 */
const ALLOWED_TAGS = [
  "p", "br", "hr", "div", "span", "b", "strong", "i", "em", "u", "s",
  "ul", "ol", "li", "blockquote", "code", "pre",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "a", "img", "figure", "figcaption",
  "table", "thead", "tbody", "tr", "td", "th",
];
const ALLOWED_ATTR = ["href", "target", "rel", "src", "alt", "title", "class", "colspan", "rowspan", "start", "type", "id"];

const CONFIG = {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  FORBID_TAGS: ["style", "script", "iframe", "object", "embed", "form", "input", "button"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "style"],
};

export default function SafeHtml({ html, className, testid }) {
  const clean = useMemo(() => DOMPurify.sanitize(html || "", CONFIG), [html]);
  return (
    <div
      data-testid={testid}
      className={className}
      // Sanitised by DOMPurify above — no untrusted HTML reaches innerHTML.
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
